import http from '../plugins/axios';
export async function get_all_customer(payload) {
    const response = await http.get('g/CUSTOMER', { params: payload });
    return response.data;
}

export async function create_customer(payload) {
    const response = await http.post('g/CUSTOMER', payload);
    return response.data;
}